module.exports = __webpack_public_path__ + "lp/img/prev.edd61099.svg";